module.exports = __webpack_public_path__ + "static/media/wizualizacja-100.7d418792.png";